var _rect, _ellipse, _rect2, _ellipse2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterborder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 443,
    viewBox: "0 0 1440 443",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 146,
    width: 657,
    height: 53,
    fill: "#610C7D"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 206,
    ry: 24,
    transform: "matrix(-1 0 0 1 1266 175)",
    fill: "#610C7D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1099,
    y: 176,
    width: 337,
    height: 23,
    fill: "#610C7D"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 331.5,
    ry: 58,
    transform: "matrix(-1 0 0 1 325.5 141)",
    fill: "#610C7D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1679.78 260.507C1669.86 242.928 1646.66 228.95 1622.74 216.571C1553.2 180.579 1474.03 145.882 1381.63 132.428C1258.44 114.496 1148.51 152.334 1036.21 174.609C970.475 187.639 898.357 193.814 831.833 182.199C686.461 156.818 526.43 0.783906 367.647 0.00578528C236.612 -0.630859 158.258 51.4891 72.5929 89.5746C9.8724 117.46 -54.0213 149.313 -121.595 171.419C-211.31 200.782 -307.496 212.977 -416.056 175.974C-417.192 175.585 -418.304 175.196 -419.452 174.807C-477.147 154.633 -549.919 122.956 -616.987 149.752C-653.527 164.338 -666.457 191.544 -673.792 216.727C-674.767 220.15 -675.718 223.567 -676.583 226.991C-677.484 230.429 -678.324 233.852 -679.053 237.29C-692.328 296.519 -688.969 356.958 -669 415.579C-664.925 427.619 -655.096 442.205 -633.732 442.969C-611.244 443.775 -598.784 428.772 -590.943 416.682C-553.365 358.868 -486.495 313.567 -405.547 276.812C-322.871 239.25 -225.499 210.65 -129.745 186.818C-129.152 186.663 -128.547 186.521 -127.955 186.366C-56.4911 168.632 11.3049 148.45 82.6943 130.921C225.597 95.8491 374.55 84.1702 512.476 133.503C639.386 178.889 726.595 263.577 893.467 258.632C1049.76 254.013 1134.63 148.16 1287.3 151.86C1338.54 153.105 1385.72 169.622 1420.78 191.07C1465.36 218.332 1489.8 253.27 1529.19 282.619C1536.01 287.705 1543.31 292.664 1551.32 297.163C1561.1 302.638 1571.93 307.399 1584.21 310.787C1606.58 316.963 1634.63 317.882 1655.45 310.137C1682.47 300.042 1689.65 278.078 1679.78 260.507Z",
    fill: "url(#paint0_linear_993_666)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_993_666",
    x1: 458.026,
    y1: 13.8314,
    x2: 473.217,
    y2: 344.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8700A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#980089"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterborder);
export default __webpack_public_path__ + "static/media/footer.border.362314cb7dc1257d345a1a076fc3360f.svg";
export { ForwardRef as ReactComponent };